// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.es-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}

.es-readings {
  display: grid;
  grid-template-columns: 1fr;
}

.es-reading-card {
  border: 1px solid #ffffff;
  border-radius: 4px;
  background: #ffffff;
  padding: 0.55rem;
}

.es-reading-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}

.es-temperature-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 0.65rem;
  margin-bottom: 0.65rem;
}

.es-temperature-row .test-detail-label,
.es-value-cell .test-detail-label {
  min-width: auto;
  white-space: nowrap;
  margin-bottom: 0;
}

.es-input {
  height: 1.85rem;
  font-size: 0.78rem;
  width: 100%;
  max-width: none;
  text-align: left;
}

.es-temperature-input {
  max-width: none;
}

.es-values-row {
  align-items: end;
}

.es-values-row.test-detail-fields {
  width: min(100%, 41rem);
  grid-template-columns: repeat(4, minmax(0, 10rem));
}

.es-value-cell {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.3rem;
  min-width: 0;
}

.es-value-cell-average input[readonly] {
  background-color: #e9ecef;
  color: #6c757d;
  font-weight: 600;
}

@media (max-width: 991.98px) {
  .es-values-row {
    gap: 10px;
  }
}
@media (max-width: 575.98px) {
  .es-values-row.test-detail-fields {
    width: 100%;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-electrical-stability-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAa3H;;AAZA;EAAsB,aAAA;EAAe,2DAAA;EAA6D,iBAAA;AAkBlG;;AAjBA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AAuB5D;;AAtBA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AA6BjE;;AA3BA;EACC,aAAA;EACA,yBAAA;EACA,qBAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,0BAAA;AA8BD;;AA3BA;EACC,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;AA8BD;;AA3BA;;EAEC,eAAA;EACA,mBAAA;EACA,gBAAA;AA8BD;;AA3BA;EACC,eAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA8BD;;AA3BA;EACC,eAAA;AA8BD;;AA3BA;EACC,gBAAA;AA8BD;;AA3BA;EACC,uBAAA;EACA,kDAAA;AA8BD;;AA3BA;EACC,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AA8BD;;AA3BA;EACC,yBAAA;EACA,cAAA;EACA,gBAAA;AA8BD;;AA3BA;EACC;IACC,SAAA;EA8BA;AACF;AA3BA;EACC;IACC,WAAA;IACA,gDAAA;EA6BA;AACF","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-field { display: flex; flex-direction: column; gap: 0.3rem; }\n.test-detail-label { margin: 0; font-size: 0.85rem; color: #555; font-weight: 600; }\n\n.es-toolbar {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-bottom: 0.5rem;\n}\n\n.es-readings {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr;\n}\n\n.es-reading-card {\n\tborder: 1px solid #ffffff;\n\tborder-radius: 4px;\n\tbackground: #ffffff;\n\tpadding: 0.55rem;\n}\n\n.es-reading-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 0.4rem;\n\tmargin-bottom: 0.5rem;\n}\n\n.es-temperature-row {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: flex-end;\n\tgap: 0.65rem;\n\tmargin-bottom: 0.65rem;\n}\n\n.es-temperature-row .test-detail-label,\n.es-value-cell .test-detail-label {\n\tmin-width: auto;\n\twhite-space: nowrap;\n\tmargin-bottom: 0;\n}\n\n.es-input {\n\theight: 1.85rem;\n\tfont-size: 0.78rem;\n\twidth: 100%;\n\tmax-width: none;\n\ttext-align: left;\n}\n\n.es-temperature-input {\n\tmax-width: none;\n}\n\n.es-values-row {\n\talign-items: end;\n}\n\n.es-values-row.test-detail-fields {\n\twidth: min(100%, 41rem);\n\tgrid-template-columns: repeat(4, minmax(0, 10rem));\n}\n\n.es-value-cell {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: stretch;\n\tgap: 0.3rem;\n\tmin-width: 0;\n}\n\n.es-value-cell-average input[readonly] {\n\tbackground-color: #e9ecef;\n\tcolor: #6c757d;\n\tfont-weight: 600;\n}\n\n@media (max-width: 991.98px) {\n\t.es-values-row {\n\t\tgap: 10px;\n\t}\n}\n\n@media (max-width: 575.98px) {\n\t.es-values-row.test-detail-fields {\n\t\twidth: 100%;\n\t\tgrid-template-columns: repeat(2, minmax(0, 1fr));\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
